var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHospitalSelected = function SvgHospitalSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#hospital-selected_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#hospital-selected_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.255 8.003C16.794 7.847 10 13.818 10 21.576c0 7.936 7 12.606 7 12.606L24 40l7-5.818s7-4.849 7-12.606c0-7.758-6.432-13.42-13.745-13.573Z",
    fill: "#1C1E21"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.667 16h-9.334c-.733 0-1.326.6-1.326 1.333L18 26.667C18 27.4 18.6 28 19.333 28h9.334C29.4 28 30 27.4 30 26.667v-9.334C30 16.6 29.4 16 28.667 16Zm0 10.667h-9.334v-9.334h9.334v9.334ZM23 25.333h2V23h2.333v-2H25v-2.333h-2V21h-2.333v2H23v2.333Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hospital-selected_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "hospital-selected_svg__b",
    x: 4,
    y: 6,
    width: 40,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_377_463"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_377_463",
    result: "shape"
  })))));
};
export default SvgHospitalSelected;